import { File } from "../../file/file.model";
import { DateUtil } from "../../shared/date_util";

export class LogFile extends File {

    private _uploaded_by_type: string = "";
    private _uploaded_by_id: number = -1;
    private _uploaded_by_name: string = "";
    private _associated_dealer_id: number = -1;
    private _associated_dealer_name: string = "";

    public get uploaded_by_type(): string {
        return this._uploaded_by_type;
    }

    public set uploaded_by_type(value: string) {
        this._uploaded_by_type = value;
    }

    public get uploaded_by_id(): number {
        return this._uploaded_by_id;
    }

    public set uploaded_by_id(value: number) {
        this._uploaded_by_id = value;
    }

    public get uploaded_by_name(): string {
        return this._uploaded_by_name;
    }

    public set uploaded_by_name(value: string) {
        this._uploaded_by_name = value;
    }

    public get associated_dealer_id(): number {
        return this._associated_dealer_id;
    }

    public set associated_dealer_id(value: number) {
        this._associated_dealer_id = value;
    }

    public get associated_dealer_name(): string {
        return this._associated_dealer_name;
    }

    public set associated_dealer_name(value: string) {
        this._associated_dealer_name = value;
    }

    public static toLogFiles(obj: string | Object[]): LogFile[] {
        let obj2 = obj;

        // If not string, then assumption is an
        // array of objects.
        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        let logFiles: LogFile[] = [];

        for (const o2 of (<Object[]>obj2)) {
            logFiles.push(LogFile.toLogFile(o2));
        }

        return logFiles;
    }

    public static toLogFile(obj: string | Object): LogFile {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of LogFile.
        return Object.assign(new LogFile(), obj2);
    }
}
